import { render } from "./RecordAttendance.vue?vue&type=template&id=172580bb&scoped=true"
import script from "./RecordAttendance.vue?vue&type=script&lang=js"
export * from "./RecordAttendance.vue?vue&type=script&lang=js"

import "./record-attendance.scss?vue&type=style&index=0&id=172580bb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172580bb"]])

export default __exports__